module.exports = __webpack_public_path__ + "assets/img/block-hover-9bc66c5c.png";